import React from "react";
import { Route, Switch } from "polyrouter";
import { AccessTokenDetails } from "./View/AccessTokenDetails";
import { AccessTokenList } from "./List/AccessTokenList";

export const AccessTokensRouter: React.FC = () => {
  return (
    <Switch nest>
      <Route nest path="/details/:id">
        <AccessTokenDetails />
      </Route>
      <Route path="">
        <AccessTokenList />
      </Route>
    </Switch>
  );
};
